import React, { useEffect, useState } from "react";
import "../../styles/components/navbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setisLoginUser } from "../../redux/features/authSliceandSidebar";
import ConfimationModal from "../modals/ConfirmationModal";

const Navbar = ({ userName, isSidebarOpen, toggleSidebar }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      if (isMobile) {
        setIsMobile(false);
      }
      setIsMobile(window.innerWidth <= 768);
      // setIsOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate("/");
    dispatch(setisLoginUser(false));
  };

  return (
    <>
      <div className="navbar">
        <button className="hamburger-btn" onClick={toggleSidebar}>
          <i className={`fas ${isSidebarOpen ? "fa-times" : "fa-bars"}`}></i>
        </button>
        <div className="welcome-text">
          TRACK - Trip Recording & Asset Control Keeper{" "}
        </div>
        {/* <div className="welcome-text">Welcome {userName} !</div> */}

        <div
          className="profile-dropdown"
          onMouseEnter={() => {
            if (!isMobile) {
              setIsDropdownOpen(true);
            }
          }}
          onMouseLeave={() => {
            if (!isMobile) {
              setIsDropdownOpen(false);
            }
          }}
          onClick={(e) => {
            setIsDropdownOpen(!isDropdownOpen);
          }}
        >
          <button className="profile-btn">
            <i className="fas fa-user"></i> {userName?.split(" ")[0]}
            <i className="fas fa-caret-down"></i>
          </button>
          {isDropdownOpen && (
            <div className="dropdown-content">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsDropdownOpen(false);
                  navigate("/profile");
                }}
              >
                <i className="fas fa-user-circle"></i> My Profile
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsDropdownOpen(false);
                  setShowModal(true);
                }}
              >
                <i className="fas fa-sign-out-alt"></i> Logout
              </a>
            </div>
          )}
        </div>
      </div>

      <ConfimationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="md"
        onSubmit={() => {
          logout();
          setShowModal(false);
        }}
        title="Logout Confirmation"
      >
        <div className="container">
          <p>Are you sure you want to logout?</p>
        </div>
      </ConfimationModal>
    </>
  );
};

export default Navbar;
